import React from 'react';
import { Link } from 'react-router-dom';
import { CATEGORIES, SERVICES, WHY_US, STATS, COUNTRIES } from '../data/services';
import ContactInfo from '../components/ui/ContactInfo';
import './Overview.css';

const mainPageLinks = [
  {
    title: 'Home',
    description: 'The starting point for all our world-class services.',
    icon: '🏠',
    path: '/',
    colorClass: 'badge-saffron'
  },
  {
    title: 'About Us',
    description: 'Learn about our mission to connect the world from Mumbai.',
    icon: 'ℹ️',
    path: '/about',
    colorClass: 'badge-teal'
  },
  {
    title: 'Contact Us',
    description: 'Get in touch for personalized assistance and inquiries.',
    icon: '📞',
    path: '/contact',
    colorClass: 'badge-gold'
  },
  {
    title: 'Privacy Policy',
    description: 'Transparency about how we handle your data.',
    icon: '🔒',
    path: '/privacy-policy',
    colorClass: 'badge-navy'
  },
];

export default function Overview() {
  return (
    <div className="page-wrapper section-pad">
      <div className="container">

        {/* Hero Section */}
        <header className="overview-header animate-fade-up">
          <span className="section-badge badge-saffron">All-in-One Guide</span>
          <h1>Everything Online Worldwide</h1>
          <p>
            From private jets to global education, we've organized our entire ecosystem here for your convenience.
          </p>
        </header>

        {/* Stats / Impact Section */}
        <section className="overview-stats-grid animate-fade-in delay-1">
          {STATS.map((stat, i) => (
            <div key={i} className="stat-card">
              <span className="stat-number">{stat.num}</span>
              <span className="stat-label">{stat.label}</span>
            </div>
          ))}
        </section>

        {/* Main Navigation Map */}
        <section className="overview-section">
          <div className="section-title-wrap">
            <h2>Quick Navigation</h2>
            <p>Main sections of our platform</p>
          </div>
          <div className="overview-grid">
            {mainPageLinks.map((link, index) => (
              <Link
                to={link.path}
                key={link.title}
                className={`overview-card animate-fade-in delay-${index + 2}`}
              >
                <div className={`overview-card-icon ${link.colorClass}`}>
                  {link.icon}
                </div>
                <h3>{link.title}</h3>
                <p>{link.description}</p>
              </Link>
            ))}
          </div>
        </section>

        {/* Detailed Service Directory */}
        <section className="overview-section service-directory">
          <div className="section-title-wrap">
            <h2>Service Directory</h2>
            <p>A complete list of our 50+ specialized services</p>
          </div>
          <div className="service-categories-grid">
            {CATEGORIES.filter(cat => cat.id !== 'all').map((category, catIndex) => (
              <div key={category.id} className="service-category-card animate-fade-in">
                <div className={`category-header badge-${category.color}`}>
                  <h3>{category.label}</h3>
                </div>
                <ul className="service-list">
                  {SERVICES.filter(service => service.cat === category.id).map((service) => (
                    <li key={service.id}>
                      <Link to={`/services#${service.id}`} className="service-link">
                        <span className="service-icon-small">{service.icon}</span>
                        <span className="service-title-small">{service.title}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        {/* Why Choose Us Highlight */}
        <section className="overview-section why-us-highlight">
          <div className="section-title-wrap">
            <h2>Why Choose Us</h2>
            <p>Our commitment to excellence</p>
          </div>
          <div className="why-us-grid">
            {WHY_US.map((item, i) => (
              <div key={i} className="why-item">
                <span className="why-icon">{item.icon}</span>
                <div className="why-content">
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Global Presence */}
        <section className="overview-section global-presence">
          <div className="section-title-wrap">
            <h2>Global Presence</h2>
            <p>Connecting Mumbai to these countries and beyond</p>
          </div>
          <div className="countries-flex">
            {COUNTRIES.map((country, i) => (
              <span key={i} className="country-chip">{country}</span>
            ))}
          </div>
        </section>

         {/* Final CTA */}
         <section className="overview-cta">
           <h2>Ready to get started?</h2>
           <p>Our team is available 24/7 to assist you with any service.</p>
           <ContactInfo layout="compact" theme="light" />
           <div className="cta-buttons" style={{marginTop: '2rem'}}>
             <Link to="/contact" className="btn-main">Send an Inquiry</Link>
             <a href="tel:+919967765284" className="btn-sec">Call: +91 9967 765284</a>
           </div>
         </section>

      </div>
    </div>
  );
}
